import _ from 'lodash'
import { ActionTypes } from '../../constants'
import Group from '../../models/group'
import student from '../shared/student'

const group = (state = {
  students: {},
  object: {},
  student: student(undefined, {}),
  processing: false,
  error: null,
  validationErrors: null,
  updatedOn: null,
  statistics: {},
  diplomas: {}
}, action) => {
  switch(action.type) {
  case ActionTypes._CLASS_ACTION_REQUEST:
    return { ...state, processing: true, error: null, validationErrors: null }

  case ActionTypes._CLASS_ACTION_FAILURE:
    const { error, error: { response } } = action
    return {
      ...state,
      processing: false,
      error: /(409|422)/.test(response.status) ? null : error,
      validationErrors: /(409|422)/.test(response.status) ? error.response.data : null
    }

  case ActionTypes._CLASS_ACTION_SUCCESS:
    const { students } = action.object
    return {
      ...state,
      object: new Group(action.object),
      updatedOn: action.updatedOn,
      students: _.mapValues(_.keyBy(students || [], 'id'), (value) => {
        return student(undefined, {
          type: ActionTypes._STUDENT_ACTION_SUCCESS,
          object: value
        })
      }),
      processing: false
    }

  case ActionTypes._STUDENT_ACTION_REQUEST:
  case ActionTypes._STUDENT_ACTION_SUCCESS:
    return {
      ...state,
      students: Object.assign({}, state.students, {
        [action.object.id]: student(state.students[action.object.id], {
          type: action.type,
          object: action.object
        })
      })
    }

  case ActionTypes._STUDENT_ACTION_FAILURE:
    return {
      ...state,
      students: Object.assign({}, state.students, {
        [action.object.id]: student(state.students[action.object.id], {
          type: action.type,
          object: action.object,
          error: action.error
        })
      })
    }

  default:
    return state
  }
}

export default group
